import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchVendorPerformance } from "../../../slice/vendor/vendorSlice";

const fmtSGD = (n) => "$" + Math.round(n || 0).toLocaleString("en-SG");

const VendorReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { vendors, loading, error } = useSelector((s) => s.vendorReport);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(fetchVendorPerformance({ limit: 5 }));
  }, [dispatch]);

  const filteredVendors = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return vendors;
    return vendors.filter((v) => (v.name || "").toLowerCase().includes(q));
  }, [vendors, search]);

  const handleView = (v) => {
    navigate(`/admin/VendorReports/${v.vendorId}`);
  };

  return (
    <div style={{ background: "#f5f6f8", minHeight: "100vh", padding: 24, fontFamily: "'Inter', 'Segoe UI', sans-serif" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: "#111827", margin: 0 }}>
            Vendor Performance Reports
          </h1>

          <div style={{ position: "relative", width: 260 }}>
            <svg
              width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
              style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)" }}
            >
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.3-4.3" />
            </svg>
            <input
              type="text"
              placeholder="Search vendor..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 14px 10px 34px",
                borderRadius: 10,
                border: "1px solid #e5e7eb",
                fontSize: 14,
                outline: "none",
                background: "#fff",
                boxSizing: "border-box",
              }}
            />
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: "60px 0", color: "#9ca3af" }}>Loading report...</div>
        ) : error ? (
          <div style={{ textAlign: "center", padding: "60px 0", color: "#dc2626" }}>{error}</div>
        ) : vendors.length === 0 ? (
          <div style={{ background: "#fff", borderRadius: 16, padding: "60px 0", textAlign: "center", color: "#9ca3af" }}>
            No delivered orders yet — the report will populate once vendors start fulfilling orders.
          </div>
        ) : filteredVendors.length === 0 ? (
          <div style={{ background: "#fff", borderRadius: 16, padding: "60px 0", textAlign: "center", color: "#9ca3af" }}>
            No vendors match "{search}".
          </div>
        ) : (
          <div style={{ background: "#fff", borderRadius: 16, overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#fafbfc", borderBottom: "1px solid #eef0f3" }}>
                  {["VENDOR", "ORDERS", "REVENUE", ""].map((h, i) => (
                    <th key={h || `col-${i}`} style={{
                      textAlign: "left",
                      padding: "14px 20px", fontSize: 11, fontWeight: 700,
                      color: "#9ca3af", letterSpacing: 0.5,
                    }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredVendors.map((v, idx) => (
                  <tr key={v.vendorId || idx} style={{ borderBottom: idx < filteredVendors.length - 1 ? "1px solid #f3f4f6" : "none" }}>
                    <td style={{ padding: "16px 20px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M3 21h18M3 7l9-4 9 4M4 7v14M20 7v14M9 21v-6a3 3 0 0 1 6 0v6" />
                        </svg>
                        <span style={{ fontSize: 14, fontWeight: 700, color: "#1f2937" }}>{v.name}</span>
                      </div>
                    </td>
                    <td style={{ padding: "16px 20px", fontSize: 14, color: "#374151" }}>
                      {v.orders}
                    </td>
                    <td style={{ padding: "16px 20px", fontSize: 14, fontWeight: 700, color: "#059669" }}>
                      {fmtSGD(v.subtotal)}
                    </td>
                    <td style={{ padding: "16px 20px" }}>
                      <button
                        type="button"
                        onClick={() => handleView(v)}
                        title="View vendor"
                        style={{
                          background: "none", border: "none", cursor: "pointer",
                          padding: 6, borderRadius: 8, display: "inline-flex",
                          alignItems: "center", justifyContent: "center",
                        }}
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorReport;